export {default} from "./Badge"
export {default as RightBadge} from "./RightBadge"
